import { useState } from "react";

export default function Input({
  label = "",
  isNecessary = false,
  inputSample = "",
  type = "",
  id = "",
  name = "",
  isReadOnly = true,
  isAuotComplete = false,
  isLTR = false,
  isNumeric = false,
  max,
  onChange,
  value,
}) {
  const [isFocused, setIsFocused] = useState(false);
  const inputValue = value === undefined ? inputSample : value;
  const hasValue =
    inputValue !== undefined && inputValue !== null && String(inputValue).length > 0;
  const isLabelActive = isFocused || hasValue;

  return (
    <div className="relative w-full min-h-[42px] border bg-transparent dark:bg-zi-inputbg-dark border-zi-border-light dark:border-none rounded-lg flex items-center overflow-visible hocus-within:border-zi-border-dark hocus-within:dark:border-zi-border-dark/50">
      <input
        defaultValue={value === undefined ? inputSample : undefined}
        value={value}
        type={type}
        id={id}
        placeholder=""
        name={name}
        readOnly={isReadOnly}
        autoComplete={isAuotComplete}
        inputmode={isNumeric ? "numeric" : undefined}
        pattern={isNumeric ? "[0-9]*" : undefined}
        max={max}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onInput={onChange}
        className={
          "zi-input-autofill text-sm w-full px-3 py-2 outline-none bg-transparent text-zi-text-light dark:text-zi-text-dark text-start " +
          (isLTR ? "[direction:ltr]" : "")
        }
      />
      {label && (
        <label
          htmlFor={id}
          className={`zi-floating-label pointer-events-none absolute right-2 z-10 origin-right px-1 leading-none transition-all duration-200 ease-in-out ${
            isLabelActive
              ? "top-0 -translate-y-1/2 text-xs text-zi-blue-light dark:text-zi-text-dark dark:bg-zi-inputbg-dark rounded-lg px-2.5 py-1"
              : "top-1/2 -translate-y-1/2 text-sm text-zi-text-light/50 dark:text-zi-text-dark/50 dark:bg-zi-inputbg-dark rounded-lg px-2.5 py-1"
          }`}
        >
          {label}
          {isNecessary && <sup className="text-amber-400">*</sup>}
        </label>
      )}
    </div>
  );
}
